import React, { useState } from "react";
import "./Login.css";
import AutoLogin from "./AutoLogin";
import LoginForm from "./LoginForm";

import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { isAuthenticationEnable } from "../../redux/reducers/AuthenticationSettingReducer";
import { useDispatch } from "react-redux";
import { removeNotification, sendNotification } from "../../redux/actions/NotificationAction";
import { ENotificationType } from "../../Model/ENotificationType";
import Loading from "../../Loading";
import Notification from "../Common/Notification";
import { getNotifications } from "../../redux/reducers/NotificationReducer";

export default function Login() {
  const dispatch = useDispatch();
  const isAuthEnable: boolean = useTypedSelector((state) => isAuthenticationEnable(state));

  const notifications = useTypedSelector((state) => getNotifications(state));
  const notification = notifications[0];

  const [showLoading, setShowLoading] = useState(false);
  const [showErrorNotification, setShowErrorNotification] = useState(false);

  if (window.location.href.indexOf("reset-password-error") != -1) {
    dispatch(
      sendNotification(ENotificationType.Error, "Invalid OTP. Please enter the correct one."),
    );
    setShowErrorNotification(true);
  }

  if (window.location.href.indexOf("reset-password-success") != -1) {
    dispatch(
      sendNotification(ENotificationType.Success, "Your password has been successfully updated"),
    );
    setShowErrorNotification(true);
  }

  const onNotificationClosed = () => {
    dispatch(removeNotification());
    setShowErrorNotification(false);
  };

  return (
    <div className="App">
      <div className="login-page">
        {showLoading && <Loading />}
        {isAuthEnable ? (
          <LoginForm
            setShowLoading={setShowLoading}
            setShowErrorNotification={setShowErrorNotification}
          />
        ) : (
          <AutoLogin
            setShowLoading={setShowLoading}
            setShowErrorNotification={setShowErrorNotification}
          />
        )}
        <Notification
          type={notification?.type ?? ENotificationType.Info}
          active={notification != null && showErrorNotification}
          message={notification?.message}
          onClose={onNotificationClosed}
        />
      </div>
    </div>
  );
}
